module.exports = __webpack_public_path__ + "media/images/devise/icon_2-e945cf81ae4f236d4338a0ea7c713cc4.svg";